var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDoIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0666 24.0532V22.5066C7.99998 20.6532 5.47998 17.0399 5.47998 13.1999C5.47998 6.59991 11.5466 1.42658 18.4 2.91991C21.4133 3.58658 24.0533 5.58658 25.4266 8.34658C28.2133 13.9466 25.28 19.8932 20.9733 22.4932V24.0399C20.9733 24.4266 21.12 25.3199 19.6933 25.3199H12.3466C10.88 25.3332 11.0666 24.7599 11.0666 24.0532Z",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 29.3333C14.3868 28.4666 17.6135 28.4666 20.6668 29.3333",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDoIcon02);
export default __webpack_public_path__ + "static/media/what-we-do-icon02.6b8cb3c105f0ddeb872f8a5760628eda.svg";
export { ForwardRef as ReactComponent };